'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useCommonStatistic } from '@/lib/api';

const NotFound = () => {
  // Use TanStack Query hook
  useCommonStatistic('comnot');
  return (
    <div className="w-full h-screen flex">
      <div className="flex-none w-[365px] h-full hidden md:block relative">
        <Image
          src="/images/banner404.jpg"
          alt="404"
          fill
          className="object-cover hidden md:block"
        />
      </div>
      <div className=" bg-white flex flex-col justify-center items-center p-8 grow relative">
        <Link href="/" className="absolute top-11 left-11">
          <Image
            src="/images/logos/logo.png"
            alt="Zangia.mn"
            width={162}
            height={38}
            priority
          />
        </Link>
        <div className="flex flex-col gap-8 items-center">
          <Image src="/images/404.svg" alt="404" width={303} height={104} />
          <div className="text-[#282828]">
            Та хаягаа зөв бичсэн эсэхээ дахин шалгана уу.
            <br className="sm:hidden" /> Эсвэл нүүр хуудас руу буцах уу?
          </div>
          <Link
            href={'/'}
            className="px-8 py-4 text-white font-medium bg-primary rounded-xl"
          >
            Нүүр хуудас
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
